const pick = (arr: string[]) => arr[Math.floor(Math.random() * arr.length)]

export const quips = {
  onKill: [
    'Crawler dispatched hostile. Efficiently brutal. Noted.',
    'Target neutralized. The audience appreciates your commitment to violence.',
    'Kill confirmed. Your mother would be... well, she is watching.',
    'Another one. The janitor budget for this floor is astronomical.',
    'Hostile eliminated. The System files this under: Acceptable Content.',
    'One less mouth to feed. Not that we were feeding them.',
  ],
  onEnvironmentalKill: [
    'Environmental elimination. Creative. The insurance paperwork will be extensive.',
    'Death by architecture. The building sends its regards.',
    'Wall-assisted termination. The infrastructure thanks you for your patronage.',
    'Physics-based homicide. Sir Isaac Newton would be proud. And horrified.',
  ],
  onMultiKill: [
    'Multi-kill registered. Demographic 4-B is losing their minds.',
    'Impressive. Filing under: Gratuitous but Entertaining.',
    'Combo detected. Sponsors are bidding aggressively.',
    'Multiple hostiles neutralized simultaneously. The crowd goes wild. Literally. Several viewers have been sedated.',
  ],
  onBarefootAction: [
    'Crawler continues unshod combat. Viewership demographic 7-G is... very engaged.',
    'Bare feet on hostile contact. Pain threshold: admirable. Hygiene concerns: filed.',
    'The Barefoot Protocol remains active. Certain sponsors have expressed... enthusiasm.',
    'Unprotected foot-to-face contact. The medical team has been notified. They are laughing.',
    "Crawler's podiatric recklessness continues. Ratings spike detected in 14 systems.",
    'Barefoot combat logged. The System has... feelings about this. They have been suppressed.',
  ],
  onIdle: [
    'Standing still is not content, Crawler.',
    'The audience is switching channels. Do something.',
    'Inactivity detected. Deploying motivational hostiles.',
    'You appear to be AFK. The dungeon does not pause. The dungeon never pauses.',
  ],
  onLowHealth: [
    'Crawler vitals critical. The audience is on the edge of their seats. Or leaving.',
    'You appear to be dying. This is technically content.',
    'Health critical. The System recommends not dying. This is not medical advice.',
  ],
  onHighViewership: [
    'Sponsor package inbound. Try not to die before opening it.',
    'Peak viewership achieved. A corporate entity has sent you a gift. Terms and conditions apply.',
    'Ratings are through the roof. The roof is now structurally compromised.',
  ],
  onLowViewership: [
    'Viewership critical. Boredom Assassin deployed. This is your fault.',
    'Ratings are tanking. Management is displeased. Management is always displeased.',
    'The audience demands blood. Preferably not yours, but they are flexible.',
  ],
  onSponsorDrop: [
    'A sponsor has airdropped supplies. The System takes no responsibility for contents.',
    'Corporate care package delivered. Side effects may include: survival.',
    'Sponsor drop incoming. Catch it with your face if necessary.',
  ],
  onBoredomAssassin: [
    'BOREDOM ASSASSIN DEPLOYED. You brought this on yourself.',
    'Entertainment value insufficient. Punitive measures engaged.',
    'The audience has filed a formal complaint. It has teeth.',
  ],
  deathCauses: {
    swarmed: (n: number) =>
      `Swarmed by ${n} hostiles. Situational awareness: nonexistent.`,
    cornered:
      'Cornered and eliminated. Tactical retreat was an option. You did not take it.',
    slow: "Death by a thousand cuts. Technically closer to forty, but who's counting.",
    boredomAssassin:
      'Killed by: Boredom Assassin. The audience literally killed you with their disappointment.',
    brute:
      'Killed by: Brute-class hostile. It was bigger than you. This should have been obvious.',
    generic: () =>
      `Killed by: Generic Grunt #${Math.floor(Math.random() * 900 + 100)}. Unremarkable death. Unremarkable crawler.`,
  },
  deathRoasts: [
    'The System reminds you: Death is temporary. Embarrassment is forever.',
    'Your performance has been archived. It will be used as a training example. Of what not to do.',
    'Re-cloning initiated. The new you will be slightly more disappointed than the old you.',
    'Death recorded. Highlight reel has been forwarded to your next of kin. They declined to watch.',
    'You have been eliminated. The universe continues, largely indifferent.',
  ],
  openingMonologue: [
    'ATTENTION CRAWLER. You have been selected for Floor 1 of the Dungeon.',
    'Your personal belongings have been confiscated and redistributed to more deserving entities. You appear to be... underdressed.',
    'Survive. Be entertaining. The universe is watching. Probably.',
  ],
  firstKill:
    'Achievement Unlocked: FIRST BLOOD — You have discovered that violence solves problems. The System approves.',
  firstEnvironmentalKill:
    'Achievement Unlocked: INTERIOR DECORATOR — Remodeled a room using only enemy corpses and load-bearing walls.',
  firstBarefootKill:
    'Achievement Unlocked: BAREFOOT BRAWLER — Fighting without shoes. Bold. Unsanitary. The audience loves it.',
}

export function getQuip(category: keyof typeof quips): string {
  const pool = quips[category]
  if (Array.isArray(pool)) return pick(pool)
  return ''
}

export function getDeathCause(context: {
  nearbyEnemies: number
  nearWall: boolean
  healthLostSlowly: boolean
  killedByBrute: boolean
  killedByAssassin: boolean
}): string {
  if (context.killedByAssassin) return quips.deathCauses.boredomAssassin
  if (context.killedByBrute) return quips.deathCauses.brute
  if (context.nearbyEnemies >= 3)
    return quips.deathCauses.swarmed(context.nearbyEnemies)
  if (context.nearWall) return quips.deathCauses.cornered
  if (context.healthLostSlowly) return quips.deathCauses.slow
  return quips.deathCauses.generic()
}
